import React from 'react';
import '../../styles/char-counter.css';

export const CharCounter = ({ current, max }) => {
  const remaining = max - current;
  const nearLimit = remaining <= 10;
  return (
    <span className={`char-counter${nearLimit ? ' char-counter-warn' : ''}`}>
      {current}/{max}
    </span>
  );
};
